exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n  padding: 24px !important;\n  text-align: center;\n}\n\n.container .title {\n  padding: 0 !important;\n  font-weight: 600;\n  margin: 0 0 16px 0;\n}\n\n.container .content {\n  margin-bottom: 16px;\n}\n\n.container .footer .btn {\n  width: 125px;\n}\n\n/deep/ .modal-content {\n  border-radius: 16px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/qrcode/popup/confirmDelete/modalDelete.component.css
// module id = ../../../../../src/app/pages/admin/qrcode/popup/confirmDelete/modalDelete.component.css
// module chunks = 3